import * as React from 'react'

export const PageError: React.FC<any> = (props) => {
    return (<>
        <h3>Si è verificato un errore in fase di consenso Yapily</h3>
    </>)
}

